<div class="container-fluid complyon-page corrective-actions-page px-3 px-md-4 px-xl-4 py-3">
  <div class="complyon-shell corrective-actions-shell mx-auto">
    <section class="mb-3">
      <h1 class="complyon-title mb-2 text-l">Findings & corrective actions</h1>
      <p class="complyon-subtitle mb-0 text-s">The single place that answers "did we fix the issue?" - every corrective action from audit findings, control failures, incidents and policy breaches, with owner, due date, evidence, escalation and closure approval.</p>
    </section>

    <section class="d-flex flex-wrap justify-content-between align-items-center gap-3 mb-3">
      <div class="d-flex flex-wrap align-items-center gap-1">
        <button
          v-for="tab in tabs"
          :key="tab.id"
          type="button"
          class="btn doa-tab-btn fw-semibold"
          :class="{ active: active_tab === tab.id }"
          @click="set_tab(tab.id)"
        >
          <span>{{ tab.label }}</span>
          <span v-if="tab.count !== undefined" class="doa-tab-count">{{ tab.count }}</span>
        </button>
      </div>

      <button type="button" class="btn doa-reset-btn d-inline-flex align-items-center gap-1">
        <i class="bi bi-arrow-clockwise"></i>
        <span>Reset sample</span>
      </button>
    </section>

    <div v-if="active_tab === 'all-actions'">
      <section class="row g-3 mb-3">
        <div v-for="card in all_action_cards" :key="card.label" class="col-12 col-md-6 col-xl-3">
          <article class="complyon-card rounded-4 p-3 h-100">
            <div class="complyon-stat-label text-xs">{{ card.label }}</div>
            <div class="complyon-stat-value text-l" :class="card.accent === 'red' ? 'text-danger' : card.accent === 'amber' ? 'text-warning-emphasis' : card.accent === 'green' ? 'text-success' : 'text-dark'">{{ card.value }}</div>
            <div class="complyon-stat-note mt-3 text-xs">{{ card.note }}</div>
          </article>
        </div>
      </section>

      <section class="complyon-panel rounded-4 overflow-hidden">
        <div class="d-flex align-items-start justify-content-between gap-2 px-3 pt-3">
          <div>
            <div class="complyon-section-title text-s">Corrective action register</div>
            <div class="complyon-section-subtitle text-xs">Every fix across audit findings, control failures, incident actions and policy breaches - owner, due date, status and escalation.</div>
          </div>
          <button type="button" class="btn config-navbar-primary-action finance-action-btn" @click="open_new_action_modal">
            <i class="bi bi-plus-lg"></i>
            <span>New action</span>
          </button>
        </div>

        <div class="px-3 pb-2 pt-2 d-flex flex-wrap align-items-center gap-2 border-top border-light-subtle">
          <button
            v-for="filter in all_action_filters_with_counts"
            :key="filter.id"
            type="button"
            class="btn doa-tab-btn fw-semibold"
            :class="{ active: filter.active }"
            @click="set_action_filter(filter.id)"
          >
            <span>{{ filter.label }}</span>
            <span class="doa-tab-count">{{ filter.count }}</span>
          </button>
        </div>

        <div class="table-responsive">
          <table class="table complyon-table align-middle mb-0">
            <thead>
              <tr>
                <th class="ps-3 text-xs">Ref</th>
                <th class="text-xs">Corrective action</th>
                <th class="text-xs">Source</th>
                <th class="text-xs">Owner</th>
                <th class="text-xs">Due</th>
                <th class="text-xs">Priority</th>
                <th class="text-xs">Status</th>
                <th class="pe-3"></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="row in filtered_action_rows"
                :key="row.ref"
                class="corrective-actions-row"
                :class="{ 'is-active': active_action_drawer_ref === row.ref }"
                tabindex="0"
                @click="open_action_drawer(row)"
                @keydown.enter.prevent="open_action_drawer(row)"
                @keydown.space.prevent="open_action_drawer(row)"
              >
                <td class="ps-3 fw-semibold text-success">{{ row.ref }}</td>
                <td>
                  <div class="d-flex align-items-center gap-2">
                    <div class="min-w-0">
                      <div class="fw-semibold">{{ row.action }}</div>
                      <div v-if="row.repeat" class="d-inline-flex align-items-center gap-1 mt-1 badge rounded-pill bg-danger-subtle text-danger-emphasis text-xs">
                        <i class="bi bi-arrow-repeat"></i>
                        <span>Repeat</span>
                      </div>
                    </div>
                  </div>
                </td>
                <td>
                  <div class="d-inline-flex align-items-center gap-2">
                    <i class="bi" :class="[row.source_icon, row.source_class]"></i>
                    <span>{{ row.source }}</span>
                  </div>
                </td>
                <td>{{ row.owner }}</td>
                <td class="fw-semibold">{{ row.due }}</td>
                <td>
                  <span
                    class="badge rounded-pill"
                    :class="row.priority === 'Critical' ? 'bg-danger-subtle text-danger-emphasis' : row.priority === 'High' ? 'bg-warning-subtle text-warning-emphasis' : 'bg-light text-secondary'"
                  >
                    {{ row.priority }}
                  </span>
                </td>
                <td><span class="badge complyon-badge text-xs" :class="row.status.class">{{ row.status.label }}</span></td>
                <td class="pe-3 text-end"><i class="bi bi-chevron-right finance-arrow"></i></td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
    </div>

    <div v-else-if="active_tab === 'by-source'">
      <section class="row g-3">
        <div v-for="group in by_source_cards" :key="group.title" class="col-12 col-md-6 col-xl-4">
          <article class="complyon-card rounded-4 p-3 h-100">
            <div class="d-flex align-items-start justify-content-between gap-3">
              <div class="d-flex align-items-center gap-2">
                <span class="rounded-3 d-inline-flex align-items-center justify-content-center flex-shrink-0" style="width:32px;height:32px;background:#e5f7f3;">
                  <i class="bi" :class="[group.icon, group.icon_class]"></i>
                </span>
                <div class="fw-semibold">{{ group.title }}</div>
              </div>
              <span class="badge rounded-pill bg-warning-subtle text-warning-emphasis">{{ group.badge }}</span>
            </div>

            <div class="mt-2 d-flex align-items-center gap-2">
              <div class="complyon-stat-value text-l">{{ group.value }}</div>
              <div class="text-xs">actions</div>
            </div>

            <div class="progress mt-3" style="height: 4px;">
              <div class="progress-bar" :class="group.accent === 'red' ? 'bg-danger' : 'bg-warning'" :style="{ width: `${group.progress}%` }"></div>
            </div>

            <div class="mt-3 d-flex flex-column gap-2">
              <div
                v-for="item in group.items"
                :key="`${group.title}-${item.label}`"
                class="d-flex align-items-center justify-content-between gap-3 py-1 corrective-actions-source-item"
                tabindex="0"
                @click="open_action_drawer_by_ref(item.ref)"
                @keydown.enter.prevent="open_action_drawer_by_ref(item.ref)"
                @keydown.space.prevent="open_action_drawer_by_ref(item.ref)"
              >
                <div class="d-flex align-items-center gap-2 min-w-0">
                  <span class="rounded-circle flex-shrink-0" :class="source_item_class(item.tone)" style="width:8px;height:8px;"></span>
                  <div class="text-truncate">{{ item.label }}</div>
                </div>
                <i class="bi bi-chevron-right corrective-actions-source-item-arrow"></i>
              </div>
            </div>
          </article>
        </div>
      </section>
    </div>

    <div v-else-if="active_tab === 'closure-approvals'">
      <section class="row g-3 mb-3">
        <div v-for="card in closure_cards" :key="card.label" class="col-12 col-md-6 col-xl-3">
          <article class="complyon-card rounded-4 p-3 h-100">
            <div class="complyon-stat-label text-xs">{{ card.label }}</div>
            <div class="complyon-stat-value text-l" :class="card.accent === 'red' ? 'text-danger' : card.accent === 'amber' ? 'text-warning-emphasis' : card.accent === 'green' ? 'text-success' : 'text-dark'">{{ card.value }}</div>
            <div class="complyon-stat-note mt-3 text-xs">{{ card.note }}</div>
          </article>
        </div>
      </section>

      <section class="complyon-panel rounded-4 overflow-hidden mb-3">
        <div class="px-3 pt-3">
          <div class="complyon-section-title text-s">Awaiting closure approval</div>
          <div class="complyon-section-subtitle text-xs">An action is only closed once an approver verifies the fix against the evidence on file. Open one to approve or reject.</div>
        </div>

        <div class="table-responsive">
          <table class="table complyon-table align-middle mb-0">
            <thead>
              <tr>
                <th class="ps-3 text-xs">Ref</th>
                <th class="text-xs">Corrective action</th>
                <th class="text-xs">Owner</th>
                <th class="text-xs">Evidence</th>
                <th class="text-xs">Due</th>
                <th class="text-xs"></th>
                <th class="pe-3"></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="row in awaiting_approval_rows"
                :key="row.ref"
                class="corrective-actions-row"
                tabindex="0"
                @click="open_action_drawer_by_ref(row.ref)"
                @keydown.enter.prevent="open_action_drawer_by_ref(row.ref)"
                @keydown.space.prevent="open_action_drawer_by_ref(row.ref)"
              >
                <td class="ps-3 fw-semibold text-success">{{ row.ref }}</td>
                <td class="fw-semibold">{{ row.action }}</td>
                <td>{{ row.owner }}</td>
                <td><span class="badge rounded-pill bg-success-subtle text-success-emphasis">{{ row.evidence }}</span></td>
                <td class="fw-semibold">{{ row.due }}</td>
                <td><span class="text-xs text-info">{{ row.decision }}</span></td>
                <td class="pe-3 text-end"><i class="bi bi-chevron-right finance-arrow"></i></td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      <section class="complyon-panel rounded-4 overflow-hidden">
        <div class="px-3 pt-3">
          <div class="complyon-section-title text-s">Recently closed - verified fixes</div>
          <div class="complyon-section-subtitle text-xs">Closure approvals with the verifying sign-off.</div>
        </div>

        <div class="table-responsive">
          <table class="table complyon-table align-middle mb-0">
            <thead>
              <tr>
                <th class="ps-3 text-xs">Ref</th>
                <th class="text-xs">Corrective action</th>
                <th class="text-xs">Approved by</th>
                <th class="text-xs">Date</th>
                <th class="text-xs">Decision</th>
                <th class="pe-3"></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="row in recently_closed_rows"
                :key="row.ref"
                class="corrective-actions-row"
                tabindex="0"
                @click="open_action_drawer_by_ref(row.ref)"
                @keydown.enter.prevent="open_action_drawer_by_ref(row.ref)"
                @keydown.space.prevent="open_action_drawer_by_ref(row.ref)"
              >
                <td class="ps-3 fw-semibold text-success">{{ row.ref }}</td>
                <td class="fw-semibold">{{ row.action }}</td>
                <td>{{ row.approved_by }}</td>
                <td class="fw-semibold">{{ row.date }}</td>
                <td><span class="badge complyon-badge bg-success-subtle text-success-emphasis">{{ row.decision }}</span></td>
                <td class="pe-3 text-end"><i class="bi bi-chevron-right finance-arrow"></i></td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
    </div>

    <div v-else-if="active_tab === 'repeat-detection'">
      <section class="row g-3 mb-3">
        <div v-for="card in repeat_cards" :key="card.label" class="col-12 col-md-6 col-xl-3">
          <article class="complyon-card rounded-4 p-3 h-100">
            <div class="complyon-stat-label text-xs">{{ card.label }}</div>
            <div class="complyon-stat-value text-l" :class="card.accent === 'red' ? 'text-danger' : card.accent === 'amber' ? 'text-warning-emphasis' : 'text-dark'">{{ card.value }}</div>
            <div class="complyon-stat-note mt-3 text-xs">{{ card.note }}</div>
          </article>
        </div>
      </section>

      <section class="complyon-panel rounded-4 overflow-hidden">
        <div class="px-3 pt-3">
          <div class="complyon-section-title text-s">Repeat-finding detection</div>
          <div class="complyon-section-subtitle text-xs">When the same root issue generates corrective actions again - often across different sources - the earlier fix did not stick. These need a systemic root-cause fix, not another patch.</div>
        </div>

        <div class="px-3 pb-3 pt-3">
          <div class="row g-3">
            <div v-for="group in repeat_groups" :key="group.title" class="col-12">
                <article class="complyon-card rounded-4 overflow-hidden">
                  <div class="d-flex align-items-center justify-content-between gap-3 px-3 py-3" :class="group.banner_class">
                    <div class="d-flex align-items-center gap-3 min-w-0">
                      <span class="rounded-circle d-inline-flex align-items-center justify-content-center flex-shrink-0" style="width:28px;height:28px;background:#c1261a;color:#fff;">
                        <i class="bi bi-arrow-repeat"></i>
                      </span>
                      <div class="min-w-0">
                        <div class="fw-semibold">{{ group.title }}</div>
                        <div class="text-xs">{{ repeat_group_summary(group) }}</div>
                      </div>
                    </div>
                    <div class="d-flex flex-wrap align-items-center justify-content-end gap-2">
                      <span v-for="badge in group.summary_badges" :key="`${group.title}-${badge.label}`" class="badge rounded-pill text-xs" :class="badge.class">{{ badge.label }}</span>
                    </div>
                  </div>

                  <div class="px-3 py-2">
                    <div
                      v-for="item in group.items"
                      :key="`${group.title}-${item.ref}`"
                      class="d-flex align-items-center justify-content-between gap-3 py-2 border-top border-light-subtle corrective-actions-repeat-row"
                      :class="{ 'is-active': active_action_drawer_ref === item.ref }"
                      tabindex="0"
                      @click="open_action_drawer_by_ref(item.ref)"
                      @keydown.enter.prevent="open_action_drawer_by_ref(item.ref)"
                      @keydown.space.prevent="open_action_drawer_by_ref(item.ref)"
                    >
                      <div class="d-flex align-items-center gap-2 min-w-0">
                        <span class="text-success fw-semibold">{{ item.ref }}</span>
                        <div class="text-truncate">{{ item.action }}</div>
                      </div>
                      <div class="d-flex align-items-center gap-2 flex-shrink-0">
                        <span class="corrective-actions-repeat-source">{{ repeat_item_source(item.ref) }}</span>
                        <span class="badge rounded-pill" :class="repeat_item_status_class(item.status)">{{ item.status }}</span>
                      </div>
                    </div>
                  </div>
                </article>
              </div>
          </div>
        </div>
      </section>
    </div>

    <teleport to="body">
      <div
        v-if="active_action_drawer && active_action_drawer_details"
        class="command-centre-drawer-backdrop"
        @click.self="close_action_drawer"
      ></div>

      <aside
        v-if="active_action_drawer && active_action_drawer_details"
        class="command-centre-drawer corrective-actions-drawer"
        role="dialog"
        aria-modal="true"
      >
        <header class="command-centre-drawer-header corrective-actions-drawer-header border-bottom">
          <div class="d-flex align-items-start justify-content-between gap-3">
            <div class="min-w-0">
              <div class="corrective-actions-drawer-kicker">{{ action_drawer_kicker(active_action_drawer) }}</div>
              <div class="corrective-actions-drawer-title mt-1">{{ active_action_drawer.action }}</div>
              <div class="corrective-actions-drawer-subtitle mt-1">
                Owner {{ active_action_drawer.owner }} - due {{ active_action_drawer.due }}
              </div>
            </div>
            <div class="d-flex align-items-start gap-2 flex-shrink-0">
              <span class="badge rounded-pill corrective-actions-top-pill" :class="action_status_chip_class(active_action_drawer.status.label)">
                {{ active_action_drawer.status.label }}
              </span>
              <button type="button" class="btn btn-link p-0 command-centre-drawer-close" @click="close_action_drawer" aria-label="Close drawer">
                <i class="bi bi-x-lg"></i>
              </button>
            </div>
          </div>
        </header>

        <div class="command-centre-drawer-body corrective-actions-drawer-body">
          <section v-if="active_action_drawer_details.repeat_message" class="corrective-actions-drawer-alert is-danger">
            <div class="d-flex align-items-start gap-2">
              <i class="bi bi-arrow-repeat"></i>
              <div>{{ active_action_drawer_details.repeat_message }}</div>
            </div>
          </section>

          <section class="corrective-actions-drawer-summary">
            <div class="corrective-actions-drawer-summary-item">
              <div class="corrective-actions-drawer-summary-label">Status</div>
              <div class="badge rounded-pill corrective-actions-summary-pill" :class="action_status_chip_class(active_action_drawer.status.label)">{{ active_action_drawer.status.label }}</div>
            </div>
            <div class="corrective-actions-drawer-summary-item">
              <div class="corrective-actions-drawer-summary-label">Source</div>
              <div class="d-inline-flex align-items-center gap-1 corrective-actions-summary-value">
                <i class="bi" :class="[active_action_drawer.source_icon, active_action_drawer.source_class]"></i>
                <span>{{ active_action_drawer.source }}</span>
              </div>
            </div>
            <div class="corrective-actions-drawer-summary-item">
              <div class="corrective-actions-drawer-summary-label">Priority</div>
              <div class="badge rounded-pill corrective-actions-summary-pill" :class="active_action_drawer.priority === 'Critical' ? 'bg-danger-subtle text-danger-emphasis' : active_action_drawer.priority === 'High' ? 'bg-warning-subtle text-warning-emphasis' : active_action_drawer.priority === 'Medium' ? 'bg-light text-secondary' : 'bg-light text-secondary'">{{ active_action_drawer.priority }}</div>
            </div>
            <div class="corrective-actions-drawer-summary-item">
              <div class="corrective-actions-drawer-summary-label">Due</div>
              <div class="corrective-actions-summary-date">{{ active_action_drawer.due }}</div>
            </div>
          </section>

          <section class="corrective-actions-drawer-section">
            <div class="corrective-actions-drawer-section-title">Corrective action workflow</div>
            <div class="corrective-actions-drawer-workflow">
              <span
                v-for="step in active_action_workflow"
                :key="`${active_action_drawer.ref}-${step.label}`"
                class="corrective-actions-drawer-workflow-chip"
                :class="action_workflow_chip_class(step.state)"
              >
                <span class="corrective-actions-drawer-workflow-chip-icon">
                  <i class="bi" :class="workflow_step_icon(step.state)"></i>
                </span>
                {{ step.label }}
              </span>
            </div>
          </section>

          <section class="corrective-actions-drawer-section">
            <div class="corrective-actions-drawer-section-title">{{ drawer_source_heading(active_action_drawer.source) }}</div>
            <article class="corrective-actions-origin-card">
              <div class="d-flex align-items-start gap-3">
                <div class="corrective-actions-origin-icon">
                  <i class="bi" :class="[active_action_drawer.source_icon, active_action_drawer.source_class]"></i>
                </div>
                <div class="min-w-0 flex-grow-1">
                  <div class="corrective-actions-origin-code">{{ active_action_drawer.source_reference || active_action_drawer.ref }}</div>
                  <div class="corrective-actions-origin-title">{{ active_action_drawer.source_name || active_action_drawer.action }}</div>
                </div>
                <i class="bi bi-box-arrow-up-right corrective-actions-origin-link"></i>
              </div>
              <div class="corrective-actions-origin-note mt-2">{{ active_action_drawer.issue_being_fixed }}</div>
            </article>
          </section>

          <section class="corrective-actions-drawer-section">
            <div class="corrective-actions-drawer-section-title">Connected records</div>
            <div class="corrective-actions-record-grid">
              <article v-for="record in active_action_drawer_details.connected_records" :key="`${active_action_drawer.ref}-${record.type}-${record.ref}`" class="corrective-actions-record-card">
                <div class="d-flex align-items-start gap-2">
                  <div class="corrective-actions-record-icon">
                    <i class="bi" :class="connected_record_icon(record.type)"></i>
                  </div>
                  <div class="min-w-0 flex-grow-1">
                    <div class="corrective-actions-record-type">{{ record.type }}</div>
                    <div class="corrective-actions-record-ref">{{ record.ref }}</div>
                  </div>
                  <i class="bi bi-box-arrow-up-right corrective-actions-record-link"></i>
                </div>
              </article>
            </div>
          </section>

          <section class="corrective-actions-drawer-section">
            <div class="d-flex align-items-center justify-content-between gap-2">
              <div class="corrective-actions-drawer-section-title">Evidence required</div>
              <button type="button" class="btn btn-link text-decoration-none p-0 corrective-actions-inline-link">+ Submit</button>
            </div>
            <div class="d-flex flex-wrap gap-2 mt-2">
              <span v-for="item in active_action_drawer_details.evidence_required" :key="`${active_action_drawer.ref}-${item.label}`" class="corrective-actions-evidence-chip" :class="{ 'is-complete': item.complete }">
                <i class="bi" :class="item.complete ? 'bi-check-circle' : 'bi-file-earmark'"></i>
                <span>{{ item.label }}</span>
                <span class="badge rounded-pill corrective-actions-evidence-tag" :class="evidence_tag_class(item.tag)">{{ item.tag }}</span>
              </span>
            </div>
          </section>

          <section v-if="active_action_drawer_details.submitted.length" class="corrective-actions-drawer-section">
            <div class="corrective-actions-drawer-section-title">Submitted</div>
            <div class="d-grid gap-2 mt-2">
              <article v-for="item in active_action_drawer_details.submitted" :key="`${active_action_drawer.ref}-${item.label}`" class="corrective-actions-submitted-card">
                <div class="d-flex align-items-start justify-content-between gap-2">
                  <div class="d-flex align-items-start gap-2 min-w-0">
                    <div class="corrective-actions-submitted-icon">
                      <i class="bi bi-file-earmark-check"></i>
                    </div>
                    <div class="min-w-0">
                      <div class="corrective-actions-submitted-title">{{ item.label }}</div>
                      <div class="corrective-actions-submitted-meta">{{ item.meta }}</div>
                    </div>
                  </div>
                  <span class="badge rounded-pill bg-success-subtle text-success-emphasis">{{ item.status }}</span>
                </div>
              </article>
            </div>
          </section>

          <section v-if="active_action_drawer_details.escalation" class="corrective-actions-drawer-section">
            <div class="corrective-actions-drawer-section-title">Escalation</div>
            <article class="corrective-actions-drawer-alert is-danger mt-2">
              <div class="d-flex align-items-start gap-2">
                <i class="bi bi-graph-up-arrow"></i>
                <div>{{ active_action_drawer_details.escalation }}</div>
              </div>
            </article>
          </section>

          <section class="corrective-actions-drawer-section">
            <div class="corrective-actions-drawer-section-title">Closure approval</div>
            <div v-if="active_action_drawer_details.closure.type === 'verified'" class="corrective-actions-closure-card is-verified">
              <div class="d-flex align-items-start gap-2">
                <div class="corrective-actions-closure-icon">
                  <i class="bi bi-check-circle-fill"></i>
                </div>
                <div class="min-w-0">
                  <div class="corrective-actions-closure-title">{{ active_action_drawer_details.closure.title }}</div>
                  <div class="corrective-actions-closure-meta">{{ active_action_drawer_details.closure.meta }}</div>
                </div>
              </div>
              <div class="corrective-actions-closure-note-card mt-2">{{ active_action_drawer_details.closure.note }}</div>
            </div>
            <div v-else-if="active_action_drawer_details.closure.type === 'awaiting'" class="corrective-actions-closure-card is-awaiting">
              <div class="d-flex align-items-start gap-2">
                <div class="corrective-actions-closure-icon">
                  <i class="bi bi-hourglass-split"></i>
                </div>
                <div class="min-w-0">
                  <div class="corrective-actions-closure-title">{{ active_action_drawer_details.closure.title }}</div>
                  <div class="corrective-actions-closure-note">{{ active_action_drawer_details.closure.note }}</div>
                </div>
              </div>
              <button type="button" class="btn corrective-actions-closure-btn mt-2">{{ active_action_drawer_details.closure.button }}</button>
            </div>
            <div v-else class="corrective-actions-closure-note">
              {{ active_action_drawer_details.closure.note }}
            </div>
          </section>

          <section class="corrective-actions-drawer-section">
            <div class="corrective-actions-drawer-section-title">Activity trail</div>
            <div class="corrective-actions-timeline">
              <div v-for="item in active_action_drawer_details.activity" :key="`${active_action_drawer.ref}-${item.actor}-${item.date}`" class="corrective-actions-timeline-item">
                <div class="corrective-actions-timeline-marker"></div>
                <div class="corrective-actions-timeline-content">
                  <div class="d-flex align-items-center justify-content-between gap-2">
                    <div class="corrective-actions-timeline-actor">{{ item.actor }}</div>
                    <div class="corrective-actions-timeline-date">{{ item.date }}</div>
                  </div>
                  <div class="corrective-actions-timeline-note">{{ item.note }}</div>
                </div>
              </div>
            </div>
          </section>
        </div>

        <footer class="command-centre-drawer-footer corrective-actions-drawer-footer">
          <div class="d-flex align-items-center justify-content-between gap-2">
            <div class="d-flex align-items-center gap-2 flex-wrap">
              <button v-if="active_action_drawer_details.footer.left" type="button" class="btn btn-link text-decoration-none corrective-actions-footer-link">
                <i v-if="footer_action_icon(active_action_drawer_details.footer.left)" class="bi me-1" :class="footer_action_icon(active_action_drawer_details.footer.left)"></i>
                {{ active_action_drawer_details.footer.left }}
              </button>
            </div>
            <div class="d-flex align-items-center gap-2 flex-wrap justify-content-end">
              <button v-if="active_action_drawer_details.footer.middle" type="button" class="btn btn-link text-decoration-none corrective-actions-footer-link">
                <i v-if="footer_action_icon(active_action_drawer_details.footer.middle)" class="bi me-1" :class="footer_action_icon(active_action_drawer_details.footer.middle)"></i>
                {{ active_action_drawer_details.footer.middle }}
              </button>
              <button v-if="active_action_drawer_details.footer.primary" type="button" class="btn config-navbar-primary-action corrective-actions-footer-primary">
                {{ active_action_drawer_details.footer.primary }}
              </button>
            </div>
          </div>
        </footer>
      </aside>

      <div
        v-if="show_new_action_modal"
        class="corrective-action-modal-backdrop"
        @click="close_new_action_modal"
      ></div>

      <section
        v-if="show_new_action_modal"
        class="corrective-action-modal"
        role="dialog"
        aria-modal="true"
        aria-label="New corrective action"
      >
        <div class="corrective-action-modal-panel">
          <div class="corrective-action-modal-header">
            <div class="d-flex align-items-start justify-content-between gap-3">
              <div class="min-w-0">
                <h2 class="corrective-action-modal-title mb-2">New corrective action</h2>
                <p class="corrective-action-modal-subtitle mb-0">
                  Evidence, escalation and closure approval are managed inside the action file.
                </p>
              </div>
              <button
                type="button"
                class="btn btn-link text-decoration-none p-0 corrective-action-modal-close"
                @click="close_new_action_modal"
                aria-label="Close modal"
              >
                <i class="bi bi-x-lg fs-6"></i>
              </button>
            </div>
          </div>

          <form class="corrective-action-modal-body" @submit.prevent="create_new_action">
            <div class="row g-3">
              <div class="col-12">
                <label class="corrective-action-modal-field-label text-xs">Corrective action</label>
                <input
                  v-model="new_action_form.action"
                  type="text"
                  class="form-control corrective-action-modal-input"
                  placeholder="What will be done to fix the issue"
                />
              </div>

              <div class="col-12">
                <label class="corrective-action-modal-field-label text-xs">Issue being fixed</label>
                <textarea
                  v-model="new_action_form.issue_being_fixed"
                  rows="2"
                  class="form-control corrective-action-modal-input corrective-action-modal-textarea"
                  placeholder="The finding / failure / breach this addresses"
                ></textarea>
              </div>

              <div class="col-12 col-md-6">
                <label class="corrective-action-modal-field-label text-xs">Source</label>
                <select v-model="new_action_form.source" class="form-select corrective-action-modal-input">
                  <option v-for="source in action_source_options" :key="source" :value="source">{{ source }}</option>
                </select>
              </div>

              <div class="col-12 col-md-6">
                <label class="corrective-action-modal-field-label text-xs">Source reference</label>
                <input
                  v-model="new_action_form.source_reference"
                  type="text"
                  class="form-control corrective-action-modal-input"
                  placeholder="e.g. AFS-2026-001 / C-101"
                />
              </div>

              <div class="col-12">
                <label class="corrective-action-modal-field-label text-xs">Source name</label>
                <input
                  v-model="new_action_form.source_name"
                  type="text"
                  class="form-control corrective-action-modal-input"
                  placeholder="Name of the finding / control / policy"
                />
              </div>

              <div class="col-12 col-md-6">
                <label class="corrective-action-modal-field-label text-xs">Root issue (for repeat detection)</label>
                <input
                  v-model="new_action_form.root_issue"
                  type="text"
                  class="form-control corrective-action-modal-input"
                  placeholder="e.g. SCM record retention"
                />
              </div>

              <div class="col-12 col-md-6">
                <label class="corrective-action-modal-field-label text-xs">Owner</label>
                <input
                  v-model="new_action_form.owner"
                  type="text"
                  class="form-control corrective-action-modal-input"
                  placeholder="Name - function"
                />
              </div>

              <div class="col-12 col-md-6">
                <label class="corrective-action-modal-field-label text-xs">Due date</label>
                <input v-model="new_action_form.due_date" type="date" class="form-control corrective-action-modal-input" />
              </div>

              <div class="col-12 col-md-6">
                <label class="corrective-action-modal-field-label text-xs">Priority</label>
                <select v-model="new_action_form.priority" class="form-select corrective-action-modal-input">
                  <option v-for="priority in action_priority_options" :key="priority" :value="priority">{{ priority }}</option>
                </select>
              </div>

              <div class="col-12 col-md-6">
                <label class="corrective-action-modal-field-label text-xs">Status</label>
                <select v-model="new_action_form.status" class="form-select corrective-action-modal-input">
                  <option v-for="status in action_status_options" :key="status" :value="status">{{ status }}</option>
                </select>
              </div>

              <div class="col-12 col-md-6">
                <label class="corrective-action-modal-field-label text-xs">Escalated</label>
                <select v-model="new_action_form.escalated" class="form-select corrective-action-modal-input">
                  <option v-for="option in action_escalation_options" :key="option" :value="option">{{ option }}</option>
                </select>
              </div>
            </div>

            <div v-if="new_action_error" class="corrective-action-modal-error mt-3">
              {{ new_action_error }}
            </div>
          </form>

          <div class="corrective-action-modal-footer">
            <button type="button" class="btn corrective-action-modal-cancel" @click="close_new_action_modal">Cancel</button>
            <button type="button" class="btn corrective-action-modal-submit d-inline-flex align-items-center gap-2" @click="create_new_action">
              <i class="bi bi-plus-lg"></i>
              <span>Create</span>
            </button>
          </div>
        </div>
      </section>
    </teleport>
  </div>
</div>
